const Tooltip = ({ title, placement, children, iconClass='info-icon' }) => {

    const html = <div className="tippy-box__inside">
        <div className="tippy-box__inside--title">
            {title}
            <span className="tooltip-close">
                &times;
            </span>
        </div>
        <div className="tippy-box__inside--content" dangerouslySetInnerHTML={{__html: children}}></div>
    </div>;

    return <span className={iconClass} data-module="tooltip" data-placement={placement}>{(iconClass === 'info-icon') ? '?' : ''} <div data-content style={{ display: "none" }}>{html}</div> </span>;
};


export default Tooltip;
